import React from "react";
import WeatherIcon from "./WeatherIcon";

export default function WeatherForecastDay(props) {
  function maxTemp() {
    let temperature = Math.round(props.data.temperature.maximum);
    return `${temperature}°`;
  }

  function minTemp() {
    let temperature = Math.round(props.data.temperature.minimum);
    return `${temperature}°`;
  }

  function day() {
    let date = new Date(props.data.time * 1000);
    let day = date.getDay();

    let days = ["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat"];

    return days[day];
  }

  return (
    <div>
      <span className="weekDay">
        <strong>{day()}</strong>
      </span>
      <div className="dailyWeatherIcon">
        <WeatherIcon code={props.data.condition.icon} size="32" />
      </div>
      <span className="max-temp">
        <strong>{maxTemp()}</strong>
        &nbsp;
      </span>
      <span className="min-temp">{minTemp()}</span>
    </div>
  );
}
